/*WINDOW RESIZE*/
$(window).resize(function () {
    $(".page footer .sitebar .navbar-nav .row li ul").removeAttr('style');
});
